import rewardoLogo from '@rewardopl/assets/logos/rewardo.svg';

import { Image, Wrapper } from './rewardo_logo.styles';

type RewardoLogoProps = { width?: number };

export default function RewardoLogo({ width = 102 }: RewardoLogoProps) {
  const height = width * (23 / 102);

  return (
    <Wrapper>
      <Image alt="Rewardo" height={height} src={rewardoLogo} width={width} />
    </Wrapper>
  );
}
